import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=a28ec202&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationPanel.vue?vue&type=style&index=0&id=a28ec202&prod&lang=scss&scoped=true"
import style1 from "./NotificationPanel.vue?vue&type=style&index=1&id=a28ec202&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28ec202",
  null
  
)

export default component.exports